import _curry2, { CurriedFunction2 } from './_internal/_curry2';

const findIndex: CurriedFunction2<Predicate<any>, any[], number> = _curry2(_findIndex);

export default findIndex;

function _findIndex<T>(fn: Predicate<T>, list: T[]): number {
   let i = 0;
   while (i < list.length) {
      if (fn(list[i])) {
         return i;
      }
      i++;
   }
   return -1;
}
